module.exports = "<app-header></app-header>\n<div class=\"animated fadeIn\">\n    <router-outlet ></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/administrador/Trabajos/pascal3/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main